import { Box, Grid, Paper, makeStyles } from "@material-ui/core";
import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import PersonalCompanyInformationForm from "views/User/OnBoard/Company/PersonalCompanyInformationForm";
import VerificationCompanyForm from "views/User/OnBoard/Company/VerificationCompanyForm";
import ProgressOnboard from "views/User/OnBoard/ProgressOnboard";
import BillingParticipantForm from "views/User/OnBoard/Company/BillingCompanyForm";
import AgreementForm from "views/User/OnBoard/Company/CompanyAgreementForm";
import AppColor from "utilities/AppColor";
import { useDispatch } from "react-redux";
import { showToast } from "store/slices/toast";
import AppButton from "components/CustomButtons/AppButton";
import { useHistory, useParams } from "react-router-dom";
import AppConfig, { PART_TYPE_COMPANY } from "config/AppConfig";
import { fetchCompanyCreateByAdmin } from "store/slices/company";
import md5 from "md5";
import { fetchCompanyFeedback } from "store/slices/company";
import { fetchCompanyDetail } from "store/slices/company";
import AppDialog from "components/Dialog/AppDialog";
import ComponentLoading from "components/Common/ComponentLoading";
import AppConfirmDialog from "components/Dialog/AppConfirmDialog";
import { fetchActiveCompany } from "store/slices/company";
import { fetchUpdateCompanyPersonalInfo } from "store/slices/company";
import AppUtil from "utilities/AppUtil";
import { fetchCompanyUpdateVerification } from "store/slices/company";
import { fetchCompanyUpdateAgreement } from "store/slices/company";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { fetchCompanyUpdateBillingInfo } from "store/slices/company";
import AdminFeedbackForm from "views/User/OnBoard/AdminFeedbackForm";
import { fetchVerifyCompany } from "store/slices/company";
import CompanyUserTable from "./CompanyUserTable";
import { reduceActivateCompany } from "store/slices/company";
import { reduceDeActivateCompany } from "store/slices/company";
import { useMedia } from "react-use";

const stripePromise = loadStripe(
  `${process.env.REACT_APP_CLIENT_STRIPE}`
);

const { APPROVAL_STATUS } = AppConfig;

const styles = makeStyles(() => ({
  container: {
    padding: "1rem",
    height: "auto",
  },
  wrapper: {
    padding: "1rem",
    border: "1px solid #d2d2d2",
  },
  wrapperLeft: {
    padding: "0 1rem 1rem 1rem",
    marginRight: "1rem",
    border: "1px solid #d2d2d2",
  },
  wrapperBottom: {
    padding: "0 1rem 1rem 1rem",
    marginBottom: "1rem",
    border: "1px solid #d2d2d2",
  },
  wrapperRight: {
    padding: "1rem",
    border: "1px solid #d2d2d2",
  },
  boxActive: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "2rem 0.5rem",
  },
  boxActivate: {
    display: "flex",
    justifyContent: "space-evenly",
    alignItems: "center",
    padding: "2rem 0.5rem",
  },
  title: {
    display: "flex",
    marginBottom: "1rem",
    "& h5": {
      color: AppColor.mainColor,
    },
  },
}));

const companyOnboard = [
  {
    label: "title.generalInformation",
    checked: false,
    code: PART_TYPE_COMPANY.GENERAL_INFO,
  },
  {
    label: "title.verification",
    checked: false,
    code: PART_TYPE_COMPANY.VERIFICATION,
  },
  {
    label: "title.billingInformation",
    checked: false,
    code: PART_TYPE_COMPANY.BILLING_INFO,
  },
  {
    label: "title.agreement",
    code: PART_TYPE_COMPANY.AGREEMENT,
    checked: false,
    isAgreement: true,
  },
];

const CompanyDetailForm = () => {
  const { t } = useTranslation();
  const below768 = useMedia('(max-width: 767.2px)');
  const classes = styles();
  const dispatch = useDispatch();
  const { companyId } = useParams();
  const history = useHistory();

  const [isCreate, setIsCreate] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [progressPercent, setProgressPercent] = useState(0);
  const [currentStep, setCurrentStep] = useState(0);
  const [progress, setProgress] = useState([]);
  const [companyDetail, setCompanyDetail] = useState({});
  const [isWaitingApproval, setIsWaitingApproval] = useState(false);
  const [isValidAll, setIsValidAll] = useState(false);
  const [isActivate, setActivate] = useState(true);
  const [showConfirmActive, setShowConfirmActive] = useState(false);
  const [showConfirmActivate, setShowConfirmActivate] = useState(false);
  const [showConfirmDeActivate, setShowConfirmDeActivate] = useState(false);
  const [companyFeedback, setCompanyFeedback] = useState([]);
  const [partTypeCompany, setPartTypeCompany] = useState();
  const [isShowActivate, setShowActivate] = useState(false);
  useEffect(() => {
    if (window.location.href.includes("create")) {
      setIsCreate(true);
    } else {
      setIsCreate(false);
    }
    initProgressByCompanyType();
  }, []);
  useEffect(() => {
    if (companyId) {
      loadCompanyDetail();
      !isCreate && loadCompanyFeedback();
    }
  }, [companyId]);

  useEffect(() => {
    switch (currentStep) {
      case 0:
        setPartTypeCompany(PART_TYPE_COMPANY.GENERAL_INFO);
        break;
      case 1:
        setPartTypeCompany(PART_TYPE_COMPANY.VERIFICATION);
        break;
      case 2:
        setPartTypeCompany(PART_TYPE_COMPANY.BILLING_INFO);
        break;
      case 3:
        setPartTypeCompany(PART_TYPE_COMPANY.AGREEMENT);
        break;
      default:
        setPartTypeCompany(PART_TYPE_COMPANY.GENERAL_INFO);
        break;
    }
  }, [currentStep]);

  const loadCompanyDetail = async () => {
    const result = await dispatch(fetchCompanyDetail({ companyId: companyId }));
    if (result.payload) {
      const { company: companyInfo } = result.payload;
      initProgressByCompanyType(companyInfo.approvalStatus);
      if (
        companyInfo.approvalStatus === APPROVAL_STATUS.WAITING_FOR_APPROVAL ||
        companyInfo.approvalStatus === APPROVAL_STATUS.REJECT
      ) {
        loadCompanyFeedback(companyInfo.id);
        setIsWaitingApproval(true);
      } else {
        setIsWaitingApproval(false);
      }
      if(companyInfo.status === 'ACTIVE') {
        setActivate(true);
      } else {
        setActivate(false);
      }
      setCompanyDetail({ ...result.payload });
    } else {
      history.push("/admin/company");
    }
  };

  const loadCompanyFeedback = async () => {
    const result = await dispatch(
      fetchCompanyFeedback({ companyId: companyId })
    );
    if (result.payload) {
      setCompanyFeedback([...result.payload]);
    }
  };

  const submitGeneralInfo = async (form) => {
    let params;
    let contentData;
    let fileLogo;
    setLoading(true);
    setIsSubmitting(true);
    let result;
    if (companyId) {
      contentData = {
        companyId: companyId,
        companyInfo: {
          organizationName: form.organizationName.trim().replace(/  +/g, " "),
          address1: form.address1,
          address2: form.address2,
          email: form.emailCompany.trim(),
          postalCode: form.postalCode,
          phone: form.phone,
          lat: form.lat,
          lng: form.lng,
          domain: form.domain,
          abn: form.abn
        },
        companyUser: {
          // emailUser: form.email.trim(),
          firstName: form.firstName,
          lastName: form.lastName,
        },
        isShowRateForStaff: form.isShowRateForStaff
      };
      fileLogo = form.logo;
      params = {
        fileLogo: fileLogo,
        contentData: contentData
      };
      result = await dispatch(fetchUpdateCompanyPersonalInfo(params));
    } else {
      contentData = {
        emailUser: form.email.trim(),
        passwordHash: md5(form.password),
        firstName: form.firstName,
        lastName: form.lastName,
        domain: form.domain,
        abn: form.abn,

        organizationName: form.organizationName.trim().replace(/  +/g, " "),
        address1: form.address1,
        address2: form.address2,
        email: form.emailCompany.trim(),
        postalCode: form.postalCode,
        phone: form.phone,
        lat: form.lat,
        lng: form.lng,
        isShowRateForStaff: form.isShowRateForStaff
      };
      fileLogo = form.logo;
      params = {
        fileLogo: fileLogo,
        contentData: contentData,
      };
      result = await dispatch(fetchCompanyCreateByAdmin(params));
    }
    setLoading(false);
    setIsSubmitting(false);
    if (result.payload) {
      AppUtil.scrollToTopById("main-panel");
      handleCheckProgress(0);
      if (isCreate) {
        history.push(`/admin/company/create/${result.payload.company.id}`);

      } else {
        loadCompanyDetail();
      }
    }
  };

  const submitVerification = async (form) => {
    setLoading(true);
    setIsSubmitting(true);
    const result = await dispatch(fetchCompanyUpdateVerification(form));
    setLoading(false);
    setIsSubmitting(false);
    if (result.payload) {
      loadCompanyDetail();
      AppUtil.scrollToTopById("main-panel");
      handleCheckProgress(1);
    }
  };

  const submitBillingParticipant = async (form) => {
    setLoading(true);
    setIsSubmitting(true);
    const result = await dispatch(fetchCompanyUpdateBillingInfo(form));
    setLoading(false);
    setIsSubmitting(false);
    if (result.payload) {
      loadCompanyDetail();
      AppUtil.scrollToTopById("main-panel");
      handleCheckProgress(2);
    }
  };

  const submitAgreement = async (form) => {
    const unCheckForm = progress.find(
      (item) => !item.checked && !item.isAgreement
    );

    if (unCheckForm) {
      dispatch(
        showToast({
          type: "warning",
          message: t(`toast.warning.needCompleteAllForm`),
        })
      );
      return;
    }
    setLoading(true);
    setIsSubmitting(true);
    const result = await dispatch(
      fetchCompanyUpdateAgreement({
        ...form,
        id: companyId,
      })
    );
    setLoading(false);
    setIsSubmitting(false);
    if (result.payload) {
      loadCompanyDetail();
      AppUtil.scrollToTopById("main-panel");
    }
  };

  const handleCheckProgress = (index) => {
    if (index + 1 === progress.length) {
      return;
    }
    setCurrentStep(index + 1);
  };

  const handleProgressStatus = (index, isCheck) => {
    let clone;
    clone = [...progress];
    if (clone[index]) {
      clone[index].checked = isCheck;
      setProgress(clone);

      if (
        isCreate &&
        isCheck &&
        clone.filter((item) => item.checked === false)[0]
      ) {
        handleCheckProgress(index);
      }
    }
    let percent = clone.filter((item) => item.checked);
    const numberFormComplete = percent.length;
    const numberForm = clone.length;
    setProgressPercent(parseInt((numberFormComplete / numberForm) * 100, 10));
    if (numberFormComplete === numberForm) {
      setIsValidAll(true);
      // if (isCreate) {
      //   setTimeout(() => {
      //     history.push(`/admin/company`);
      //   }, 1000);
      // }
    }
  };

  const handleBackStep = (index) => {
    AppUtil.scrollToTopById("main-panel");
    if (
      ((!isCreate &&
        companyDetail.company.approvalStatus === APPROVAL_STATUS.PENDING) ||
        isCreate) &&
      index > currentStep
    ) {
      if (progress[currentStep].checked) {
        for (let i = currentStep; i <= index; i++) {
          if (!progress[i].checked) {
            setCurrentStep(i);
            return;
          }
        }
        setCurrentStep(index);
      } else {
        dispatch(
          showToast({
            type: "warning",
            message: t(`toast.warning.needCompleteForm`),
          })
        );
      }
      return;
    }
    setCurrentStep(index);
  };

  const handleActiveCompany = async () => {
    await dispatch(fetchActiveCompany({ companyId: companyId }));
    setShowConfirmActive(false);
    loadCompanyDetail();
  };

  const initProgressByCompanyType = (status) => {
    if (status === APPROVAL_STATUS.ACTIVE) {
      const companyOnboardActive = companyOnboard.filter((element) => {
        return element.code !== PART_TYPE_COMPANY.AGREEMENT;
      });
      setProgress(companyOnboardActive);
    } else {
      setProgress(
        companyOnboard.map((item) => {
          item.checked = false;
          return item;
        })
      );
    }
  };

  const handleRejectForm = async (form) => {
    setIsSubmitting(true);
    const { feedbackId, ...rest } = form;
    const params = {
      ...rest,
      companyId,
      partTypeCompany: partTypeCompany,
      isRejected: feedbackId ? false : true,
    };
    const result = await dispatch(fetchVerifyCompany(params));
    setIsSubmitting(false);
    if (result.payload) {
      loadCompanyFeedback();
    }
  };

  const handleActivateCompany = async () => {
    const result = await dispatch(reduceActivateCompany(companyId));
    if (result.payload) {
      loadCompanyDetail();
    }
    setShowConfirmActivate(false);
    if (isCreate) {
      history.push('/admin/company');
    }
  };

  const handleDeActivateCompany = async () => {
    const result = await dispatch(reduceDeActivateCompany(companyId));
    if (result.payload) {
      loadCompanyDetail();
    }
    setShowConfirmDeActivate(false);
  } 

  useEffect(() => {
    if ((!isCreate && companyDetail && companyDetail.company && companyDetail.company.approvalStatus !== APPROVAL_STATUS.ACTIVE) || (isCreate && !companyDetail.company) || (isCreate && companyDetail  && companyDetail.company && companyDetail.company.approvalStatus !== APPROVAL_STATUS.ACTIVE)) {
      setShowActivate(false);
    } else {
      setShowActivate(true);
    }
  }, [isCreate, companyDetail]);

  return (
    <React.Fragment>
      <Box>
        <Grid container justifyContent="center">
          <Grid item xs={12} sm={6} md={8}>
            <Paper className={below768 ? classes.wrapperBottom : classes.wrapperLeft}>
              {progress && progress.length > 0 && (
                <React.Fragment>
                  <PersonalCompanyInformationForm
                    onSubmit={submitGeneralInfo}
                    changeProgressStatus={handleProgressStatus}
                    display={currentStep === 0}
                    isCreate={isCreate}
                    companyDetail={companyDetail}
                    hideLeftControl={true}
                    // disabled={isWaitingApproval}
                    isSubmitting={isSubmitting}
                  />
                  <VerificationCompanyForm
                    onSubmit={submitVerification}
                    changeProgressStatus={handleProgressStatus}
                    companyDetail={companyDetail}
                    display={currentStep === 1}
                    hideLeftControl={true}
                    // disabled={isWaitingApproval}
                  />
                  <Elements stripe={stripePromise}>
                    <BillingParticipantForm
                      isCreate={isCreate}
                      onSubmit={submitBillingParticipant}
                      changeProgressStatus={handleProgressStatus}
                      companyDetail={companyDetail}
                      display={currentStep === 2}
                      hideLeftControl={true}
                      isSubmitting={isSubmitting}
                      // disabled={isWaitingApproval}
                    />
                  </Elements>
                  <AgreementForm
                    onSubmit={submitAgreement}
                    changeProgressStatus={handleProgressStatus}
                    companyDetail={companyDetail}
                    display={currentStep === 3}
                    // disabled={isWaitingApproval}
                    hideLeftControl={true}
                  />
                  {isWaitingApproval && (
                    <React.Fragment>
                      <hr />
                      <AdminFeedbackForm
                        onSubmit={handleRejectForm}
                        isSubmitting={isSubmitting}
                        isCompany={true}
                        display={isWaitingApproval}
                        feedback={
                          companyFeedback.filter(
                            (item) => item.partTypeCompany === partTypeCompany
                          )[0]
                        }
                      />
                    </React.Fragment>
                  )}
                </React.Fragment>
              )}
            </Paper>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <Paper className={classes.wrapperRight}>
              <ProgressOnboard
                step={currentStep}
                value={progressPercent}
                progress={progress}
                handleBackStep={handleBackStep}
                // hideCircle={!isCreate}
                feedbacks={
                  isWaitingApproval &&
                  companyFeedback.map((item) => {
                    item["partType"] = item.partTypeCompany;
                    return item;
                  })
                }
              />
            </Paper>

            <Box className={isWaitingApproval && isValidAll && companyFeedback.length === 0 ? classes.boxActivate : classes.boxActive}>
              {isShowActivate && (
                isActivate ? (
                  <React.Fragment>
                  <AppButton
                    label={`${t("button.block_company")}`}
                    onClick={() => setShowConfirmDeActivate(true)}
                    rounder
                    buttonColor={AppColor.red}
                    titleTooltip="This company and those workers, clients, ... in this company will be disable temporary."
                  />
                  </React.Fragment>

              ) : (
                  <React.Fragment>
                  <AppButton
                    label={`${t("button.active_company")}`}
                    onClick={() => setShowConfirmActivate(true)}
                    rounder
                    buttonColor={AppColor.mainColor}
                    titleTooltip="This company and those workers, clients, ... in this company will be active."
                  />
                  </React.Fragment>
              )
              )}
              {isWaitingApproval &&
                isValidAll &&
                companyFeedback.length === 0 && (
                  <AppButton
                    label={`${t("button.active")}`}
                    onClick={() => setShowConfirmActive(true)}
                    rounder
                    buttonColor={AppColor.mainColor}
                  />
                )}
            </Box>
          </Grid>
          {!isCreate && companyId && (
            <Grid item xs={12} sm={12} md={12}>
              <Paper className="mt-5 p-3">
                <CompanyUserTable companyId={companyId} />
              </Paper>
            </Grid>
          )}
        </Grid>
        <AppDialog
          open={loading}
          onClose={() => setLoading(false)}
          noTitle
          noCloseButton
          disableEscapeKeyDown
        >
          <Box my={3}>
            <ComponentLoading />
          </Box>
        </AppDialog>
        <AppConfirmDialog
          open={showConfirmActive}
          onConfirm={() => handleActiveCompany()}
          onClose={() => setShowConfirmActive(false)}
          title={t("title.activeCompany")}
          content={t("text.activeCompany")}
        />
        <AppConfirmDialog
          open={showConfirmActivate}
          onConfirm={() => handleActivateCompany()}
          onClose={() => setShowConfirmActivate(false)}
          title={t("title.activateCompany")}
          content={t("text.activateCompany")}
        />
        <AppConfirmDialog
          open={showConfirmDeActivate}
          onConfirm={() => handleDeActivateCompany()}
          onClose={() => setShowConfirmDeActivate(false)}
          title={t("title.de_activateCompany")}
          content={t("text.de_activateCompany")}
        />
      </Box>
    </React.Fragment>
  );
};

export default CompanyDetailForm;
